import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

/**
 * スライド関連の処理
 */
export default class Slide {
	constructor() {
		this.slideTop();
		this.slideNews();
		this.slideAbout();
		this.slideService();
	}
	slideTop() {
		let swiper;
		let $window_w = $(window).width();
		const breakpoint = 750;

		if ($('.p-home-top__swiper').length) {
			$(window).on('load resize', function () {
				let $window_w_resize = $(window).width();

				if ($window_w !== $window_w_resize || !swiper) {
					if (swiper) {
						swiper.destroy();
						swiper = undefined;
					}

					if ($window_w_resize <= breakpoint) {
						swiper = new Swiper(".p-home-top__swiper", {
							slidesPerView: 1,
							loop: true,
							speed: 1000,
							autoplay: {
								delay: 3000,
								disableOnInteraction: false,
							},
							effect: "fade",
							fadeEffect: {
								crossFade: true
							},
						});
					}
				}

				$window_w = $window_w_resize;
			});
		}
	}

	slideNews() {
		let swiper;
		let $window_w = $(window).width();
		const breakpoint = 750;

		if ($('.p-home-news__swiper').length) {
			$(window).on('load resize', function () {
				let $window_w_resize = $(window).width();

				if ($window_w !== $window_w_resize || !swiper) {
					if (swiper) {
						swiper.destroy();
						swiper = undefined;
					}

					if ($window_w_resize <= breakpoint) {
						// SP版
						// お知らせの記事数でオートプレイをon/off
						if ($(".p-home-news__item").length !== 1) {
							swiper = new Swiper(".p-home-news__swiper", {
								slidesPerView: 1,
								direction: "vertical",
								loop: true,
								allowTouchMove: false,
								speed: 1000,
								autoplay: {
									delay: 3000,
									disableOnInteraction: false,
								},
							});
						} else {
							swiper = new Swiper(".p-home-news__swiper", {
								slidesPerView: 1,
								direction: "vertical",
								allowTouchMove: false,
							});
						}
					} else {
						// PC版
						// お知らせの記事数でオートプレイをon/off
						if ($(".p-home-news__item").length !== 1) {
							swiper = new Swiper(".p-home-news__swiper", {
								direction: 'vertical',
								loop: true,
								on: {
									init: pcChangeSlide,
									slideChangeTransitionEnd: pcChangeSlide,
								}
							});
						} else {
							const $news_single_title = $('.p-home-news__item-title');
							const $news_single_txt = $('.p-home-news__item-title-txt');
							const title_width = $news_single_title.width();
							const txt_width = $news_single_txt.width();

							if (title_width < txt_width) {
								$news_single_txt.addClass('is-scroll-loop');
							}
						}

						function pcChangeSlide() {
							const $news_title = $('.p-home-news__item-title');
							const $news_txt = $('.swiper-slide-active .p-home-news__item-title-txt');

							const title_width = $news_title.width();
							const txt_width = $news_txt.width();

							if (title_width < txt_width) {
								$news_txt.addClass('is-scroll');
							}

							if ($news_txt.hasClass('is-scroll')) {
								$news_txt.on('animationend webkitAnimationEnd', function () {
									setTimeout(function () {
										swiper.slideNext();
										$news_txt.removeClass('is-scroll');
									}, 3000);
								});
							} else {
								setTimeout(function () {
									swiper.slideNext();
								}, 6000);
							}
						}
					}
				}

				$window_w = $window_w_resize;
			});
		}
	}

	slideAbout() {
		const swiper = new Swiper(".p-home-about__swiper", {
			slidesPerView: 1,
			loop: true,
			speed: 1000,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			effect: "fade",
			fadeEffect: {
				crossFade: true
			},

			pagination: {
				el: ".p-home-about__pagination",
				clickable: true,
			},
		});
	}

	slideService() {
		let swiper;
		let $window_w = $(window).width();
		const breakpoint = 750;

		if ($('.p-home-service__swiper').length) {
			$(window).on('load resize', function () {
				let $window_w_resize = $(window).width();
				if ($window_w !== $window_w_resize || !swiper) {
					if (swiper) {
						swiper.destroy();
						swiper = undefined;
					}

					if ($window_w_resize <= breakpoint) {
						swiper = new Swiper(".p-home-service__swiper", {
							//loop: true,
							initialSlide: 0,
							slidesPerView: 'auto',
							centeredSlides: true,
							thumbs: {
								swiper: {
									el: '.p-home-service__tab',
									slidesPerView: 4,
								}
							},
							scrollbar: {
								el: '.p-home-service__bar',
								draggable: true,
							}
						});
					}
				}

				$window_w = $window_w_resize;
			});
		}
	}
}
